import {useState,useEffect} from 'react';
import {Box,Button,TextField} from '@mui/material';
import { PromiseOr } from 'sass';


interface Post{
    id:number;
    title:string;
    body:string;
}

export default function StateApi(){
    const [posts ,setPosts] = useState<Post[]>([]);

    useEffect(()=>{
        fetchPosts();
    },[])

    const fetchPosts = async(): Promise<void> =>{
        try{
            const response = await fetch('https://jsonplaceholder.typicode.com/posts');
            const data = await response.json();
            setPosts(data);

        }catch(error){
            console.error(error);
        }
    }

    return (
        <>
        <Box>
            {posts.map((post) => (
            <div key={post.id}>
                <h3>{post.title}</h3>
                <p>{post.body}</p>
            </div>
            ))}
        </Box>
        </>
    );
}
